/**
 * Mirrors the IAM user-management API payloads.
 * Field shapes follow the Notion spec verbatim; the request interceptor
 * already converts snake_case ↔ camelCase, so client types use camelCase.
 */

export type AccountLevel = 'SUPER_ADMIN' | 'TENANT_ADMIN' | 'USER'

export const ACCOUNT_LEVEL_VALUES: AccountLevel[] = ['SUPER_ADMIN', 'TENANT_ADMIN', 'USER']

export interface UserDTO {
  id: string
  tenantId: string | null
  username: string
  email: string | null
  fullName: string | null
  avatarUrl: string | null
  phone?: string | null
  accountLevel: AccountLevel | null
  isActive: boolean
  createdAt: string
}

export interface UserCreateRequest {
  username: string
  password: string
  email?: string | null
  fullName?: string | null
  avatarUrl?: string | null
  phone?: string | null
}

export interface UserUpdateRequest {
  fullName?: string | null
  email?: string | null
  avatarUrl?: string | null
  phone?: string | null
}

export interface ChangePasswordRequest {
  newPassword: string
}

export interface UserAccountLevelUpdateRequest {
  accountLevel: AccountLevel
}

export interface ResetPasswordResponseDTO {
  userId: string
  temporaryPassword: string
}

export interface PaginatedDTO<T> {
  items: T[]
  total: number
  skip: number
  limit: number
}

export type IUser = UserDTO

export interface UserListParams {
  skip: number
  limit: number
  search?: string
  accountLevel?: AccountLevel
  isActive?: boolean
}
